import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Image,
  Input,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import { GoogleIcon } from '@Modules/core/components/ProviderIcons'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ILoginFormMeta } from '@Modules/auth/containers/forms/LoginFormMeta';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';

type Props = {
  onSubmit: (e: any) => void,
  meta: ILoginFormMeta,
  isSubmitting?: boolean,
};

export const LoginFormUI = ({ meta, onSubmit, isSubmitting }: Props) => {
  const isMobile = useBreakpointValue({ base: true, md: false })
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ 
    resolver: yupResolver(meta.schema) 
  });
  return (
    <Stack spacing="8" 
      px={{ base: '4', md: '8' }}
      py={{ base: '12', md: '48' }}
      width="full"
      maxW="md">
      <Stack spacing="6">
        {isMobile && <Image
                height={'70px'}
                objectFit='contain'
                src='/assets/images/brand/greatpay.png'
                alt='GreatPay Logo'
              />}
        <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
          <Heading size={{ base: 'sm', md: 'lg' }}>Log in to your account</Heading>
          <HStack spacing="1" justify="center">
            <Text color="muted">Don't have an account?</Text>
            <Button variant="link" colorScheme="blue">
              Sign up
            </Button>
          </HStack>
        </Stack>
      </Stack>
      <form onSubmit={onSubmit}>
        <Stack spacing="6">
          <Stack spacing="5">
            <CustomFormControl label={meta.login.name} w={"auto"} isInvalid={!!errors[meta.login.name]}>
              <CustomInput
                defaultValue='admin'
                meta={meta.login}
                register={register(meta.login.name)}
                hasError={errors[meta.login.name]}
              />
            </CustomFormControl>
            <FormControl>
              <FormLabel htmlFor="password">Password</FormLabel>
              <CustomInput
                defaultValue='admin'
                meta={meta.password}
                register={register(meta.password.name)}
                hasError={errors[meta.password.name]}
              />
            </FormControl>
          </Stack>
          <HStack justify="space-between">
            <Checkbox defaultChecked>Remember me</Checkbox>
            <Button variant="link" colorScheme="blue" size="sm">
              Forgot password
            </Button>
          </HStack>
          <Stack spacing="4">
            <Button type='submit' isLoading={isSubmitting} colorScheme="blue" variant="solid">Sign in</Button>
            <Button variant="outline" leftIcon={<GoogleIcon boxSize="5" />} iconSpacing="3">
              Sign in with Google
            </Button>
          </Stack>
        </Stack>
      </form>
    </Stack>
  )
}